/**
 * Mémoire du dernier dossier apprenant consulté, par utilisateur.
 *
 * L'écran « Dossier apprenant » s'ouvre depuis le menu sans identifiant : sans
 * cette mémoire, il n'a rien à afficher alors que la personne revient presque
 * toujours sur le dossier qu'elle instruisait. Seul l'identifiant est retenu,
 * jamais un nom ni une donnée du dossier : le contenu est rechargé par l'API,
 * qui reste l'autorité sur le droit d'y accéder.
 *
 * La clé porte l'identifiant de l'utilisateur : sur un poste partagé, chacun
 * retrouve son propre dossier et pas celui du collègue précédent.
 */
const PREFIXE = 'topformation.dernier-dossier';

function cle(utilisateurId: string): string {
  return `${PREFIXE}.${utilisateurId}`;
}

/**
 * `localStorage` peut lever — navigation privée, stockage désactivé par
 * politique. La mémoire est un confort : son échec ne doit jamais casser
 * l'écran, il ramène simplement à « aucun dossier sélectionné ».
 */
export function lireDernierDossier(utilisateurId: string | undefined): string | undefined {
  if (!utilisateurId) return undefined;
  try {
    return window.localStorage.getItem(cle(utilisateurId)) ?? undefined;
  } catch {
    return undefined;
  }
}

export function memoriserDernierDossier(
  utilisateurId: string | undefined,
  dossierId: string,
): void {
  if (!utilisateurId) return;
  try {
    window.localStorage.setItem(cle(utilisateurId), dossierId);
  } catch {
    /* stockage indisponible : la reprise sera simplement sans effet */
  }
}

export function oublierDernierDossier(utilisateurId: string | undefined): void {
  if (!utilisateurId) return;
  try {
    window.localStorage.removeItem(cle(utilisateurId));
  } catch {
    /* rien à oublier si le stockage refuse déjà de répondre */
  }
}
